import { SharedCommonModule } from '@certemy/common';
import { DisplayHtmlModule } from '@certemy/ui-components';
import { StatusLabelModule } from 'components/status-label/status-label.module';
import { StepItemIndicatorsModule } from './step-item-indicators/step-item-indicators.module';
import { RejectedHintModule } from 'components/hint/rejected-hint/rejected-hint.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepItemComponent } from './step-item.component';
import { StepIconModule } from 'components/step-icon/step-icon.module';
import { OptionalHintModule } from 'components/hint/optional-hint/optional-hint.module';

@NgModule({
  imports: [
    CommonModule,
    NgbTooltipModule,
    StepIconModule,
    RejectedHintModule,
    OptionalHintModule,
    StepItemIndicatorsModule,
    StatusLabelModule,
    DisplayHtmlModule,
    SharedCommonModule,
  ],
  declarations: [StepItemComponent],
  exports: [StepItemComponent],
})
export class StepItemModule {}
